/* eslint-disable max-params */
/* eslint-disable @typescript-eslint/naming-convention */
import {
  Permission,
  PermissionControl,
  RoleLevel,
  UserRole,
  UserRoleFormGroup,
} from '../types';
import {
  loadGeneralPermissionGrants,
  loadInternalPermissionGrants,
} from '@shared/utils/permissions.util';
import { FormControl, FormGroup } from '@angular/forms';
import { camelCase } from 'lodash';
import { STUDY_LEVEL_PERMISSIONS } from '../constants';

export function constructPermissionArray(
  isEditMode: boolean,
  permission: Permission,
  permissionName: string,
  currentLevel?: RoleLevel,
) {
  const hardCodedPermissions = {
    ...loadGeneralPermissionGrants(),
    ...loadInternalPermissionGrants(),
  };
  /**
   * @ToDO:- The below logic will change if there is a user role present.
   * **/
  const permissionControls: Partial<PermissionControl> = {};
  if (Object.keys(hardCodedPermissions).length > 0) {
    for (const hardCodedPermission of Object.values(hardCodedPermissions)) {
      if (
        hardCodedPermission.name.toLowerCase() === permission.name.toLowerCase()
      ) {
        //@TODO THIS WILL CHANGE ONCE THE LABEL PROPERLY UPDATED ON THE BACKEND FOR ORGANIZATION
        const _pName = permission.name.toLowerCase().includes('organization')
          ? permission.label
          : permission.name;
        const permissions = isEditMode
          ? {
              description: new FormControl(permission.description),
              id: permission.id,
              level: new FormControl(hardCodedPermission.level),
              name: new FormControl<string>(_pName),
              role_id: permission.roleId,
            }
          : {
              description: new FormControl(permission.description),
              level: new FormControl(hardCodedPermission.level),
              name: new FormControl<string>(_pName),
            };
        Object.assign(permissionControls, permissions);
        for (const grant of hardCodedPermission.grants) {
          if (isEditMode) {
            Object.assign(permissionControls, {
              [camelCase(grant)]: new FormControl<boolean>({
                disabled:
                  STUDY_LEVEL_PERMISSIONS.has(permissionName.toLowerCase()) &&
                  currentLevel === 'Site',
                value:
                  !!permission[camelCase(grant) as keyof typeof permission],
              }),
            });
          } else {
            Object.assign(permissionControls, {
              [camelCase(grant)]: new FormControl<boolean>(false),
            });
          }
        }
      }
    }
  }
  return permissionControls;
}

export function mapUserRoleFormGroupToUserRole(
  roles: FormGroup<UserRoleFormGroup>,
) {
  let role = {};
  if (roles) {
    const optimizingGroupPermissions = roles
      .getRawValue()
      .groupedPermissions.filter((v) => !v.isParent)
      .map((p) => ({
        can_edit: p.canEdit,
        can_remove: p.canRemove,
        can_view: p.canView,
        description: p.description,
        id: p.id,
        isParent: p.isParent,
        level: p.level,
        name: p.name,
        role_id: p.role_id,
      }));

    const r = roles.getRawValue();
    role = {
      is_internal: r.type === 'Internal',
      name: r.name,
      org_level: r.level === 'Organization',
      permissions: [...optimizingGroupPermissions],
      site_level: r.level === 'Site',
      study_level: r.level === 'Study',
    };
  }
  return role as UserRole;
}
